"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Z20Inventory = void 0;
class Z20Inventory {
    constructor() {
        this.tools = [];
    }
    addTool(tool) {
        if (this.tools.includes(tool))
            return false;
        this.tools.push(tool);
        return true;
    }
    has(tool) {
        return this.tools.includes(tool);
    }
}
exports.Z20Inventory = Z20Inventory;
